import React from 'react';
import { IconProps } from './types';

const Airways = (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 6" {...props}>
        <path fill="currentColor" d="M24 2h-5V0H5v2H0v2h5v2h14V4h5V2z" />
    </svg>
);

export default Airways;
